import { render, staticRenderFns } from "./BodyPartsViewForm.vue?vue&type=template&id=71b6f801&scoped=true&"
import script from "./BodyPartsViewForm.vue?vue&type=script&lang=ts&"
export * from "./BodyPartsViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./BodyPartsViewForm.vue?vue&type=style&index=0&id=71b6f801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6f801",
  null
  
)

export default component.exports